import { authClient, useAuth } from 'oasis-auth';
import { useAppState } from 'oasis-os-react';
import {
  createGlobal,
  getLogger,
  setLoggerLcid,
  setLoggerClient,
  readGlobal,
} from 'oasis-os-common';
import { apiClient } from 'oasis-feature-api';
import React, { useEffect } from 'react';
import { ContentfulApp, InitDataAPIConfig } from '../../types';
import { transformer } from '../../utils/transformer';
import { callDataSource } from '../../utils/callDataSource';

export interface ActionsProps {
  config: ContentfulApp;
}
const logger = getLogger(PKG_NAME, PKG_VERSION, 'Actions');

const Actions: React.FC<ActionsProps> = ({ config }: ActionsProps) => {
  const [auth] = useAuth();
  const { fields: appConfig } = config;
  const [, , app] = useAppState();
  const networkStatus = readGlobal('$.global.value.networkStatus');

  useEffect(() => {
    if (!appConfig?.config) {
      return;
    }
    
   

    const transformedData = transformer(
      appConfig.config.fields,
      auth.session?.host,
      auth.session?.swIntercept,
    );
    if (networkStatus) {
      createGlobal({ ...transformedData, networkStatus });
    } else {
      createGlobal(transformedData);
    }

    transformedData.service &&
      apiClient.init({
        service: transformedData.service,
        retries: 3,
      });

    if (auth.authenticated) {
      if (appConfig?.config?.fields?.initDataSource?.api) {
        appConfig?.config?.fields?.initDataSource?.api.map((initApiConfig: InitDataAPIConfig) => {
          if (initApiConfig?.enable === true) {
            callDataSource(initApiConfig);
          }
        });
      }

      if (auth?.session?.lcid) {
        setLoggerLcid(auth?.session?.lcid);
      }
      const publicPath = process.env.PUBLIC_PATH;
      if (publicPath) {
        const client = publicPath.replace(/\//g, '');
        setLoggerClient(client);
      }
      // optional info to work in test render
      logger?.info('Lcid and client set ');
    }

    app.registerAction('getPublicPath', () => {
      return process.env.PUBLIC_PATH ?? '/';
    });

    process.env.CUSTOM_CSS &&
      app.registerAction('punchOutLoaded', () => {
        if (process.env.CUSTOM_CSS) {
          const darkTheme = document.getElementById(process.env.CUSTOM_CSS.replace(/,/g, ' '));
          const customCss = process.env.CUSTOM_CSS.split(',');
          customCss.map((_, index: number) => {
            return darkTheme?.classList.remove(customCss[index]);
          });
        }
      });
  }, [appConfig, auth.authenticated]);

  useEffect(() => {
    if (navigator.serviceWorker) {
      navigator.serviceWorker.onmessage = (event) => {
        if (event.data === 'REFRESH') {
          authClient.refresh();
        }
      };
    }
    app.registerAction('authRefresh', () => {
      const publicShare = readGlobal('$.global.value.functionalConfig.features.publicShare');
      try {
        publicShare ? authClient.refresh('share') : authClient.refresh();
      } catch (error) {
          throw error;
      }
  });
  
  }, []);

  return <div data-testid="actions" />;
};

export default Actions;
